import { StatefulDropdown } from "app/components/dashboard/widget-wizard/components/StatefulDropdown";
import I18n from "pro-features/components/WithTranslation/src/I18n";
import React from "react";
import { currenciesList } from "app/common/constants/currencies";
export class AdSpendLineChartWidgetFilters extends React.Component<any, any> {
    protected selectedFilters: any = {};
    private granularityDisabled: boolean;
    private widgetDuration: any;
    private currencyItems: any[];

    constructor(props) {
        super(props);
        this.currencyItems = currenciesList.map((currency) => ({
            ...currency,
            id: currency.name,
            text: currency.name,
            key: currency.name,
        }));
        this.selectedFilters = {
            currency: this.props.widgetFilters.currency || this.currencyItems[0].id, //"USD",
        };
        this.props.changeFilter(this.getSelectedFilters());
    }

    public render() {
        return (
            <div
                key="dynamicFiltersContainer"
                className="filters"
            >
                <div
                    key="currencyFilter"
                    className="dynamicFilter"
                >
                    <h5>
                        <I18n>{`home.dashboards.wizard.filters.Currency`}</I18n>
                    </h5>
                    <StatefulDropdown
                        key="currency"
                        items={this.currencyItems}
                        selectedId={this.selectedFilters.currency}
                        onSelect={this.onSelectCurrency}
                    />
                </div>
            </div>
        );
    }

    private getSelectedFilters() {
        return Object.entries(this.selectedFilters).map(([name, value]) => ({ name, value }));
    }

    private onSelectCurrency = (item) => {
        this.selectedFilters.currency = item?.id;
        this.props.changeFilter(this.getSelectedFilters());
    };
}
